import React from 'react';
import './Airconditioner.css';
import ACimage from '../Assets/ac1.jpg'; // First image
import ACimage2 from'../Assets/air2.jfif'; // Image for Key Features & Benefits
import ACimage3 from '../Assets/ac3.jpg'; // Image for How it Works section
import ACimage4 from '../Assets/ac4.jpg'; // Image for Why Choose section
import ACimage5 from '../Assets/ac5.jpg'; // Image for Industries section

const Airconditioner = () => {
    return (
        <div className="FMS-card">
            <div className="FMS-container">
                {/* First Section: Layout for Text and Image */}
                <div className="FMS-content-container">
                    {/* Left side: Text Content */}
                    <div className="FMS-text">
                        <h1 className="FMS-heading">AIR CONDITIONER AUTOMATION</h1>
                        <p className="FMS-description">
                            Our Air Conditioner Automation system is designed to optimize cooling performance and energy efficiency. It intelligently controls air conditioning units, monitors temperature and energy usage, and provides real-time data to enhance comfort, reduce energy costs, and improve operational efficiency across various environments.
                        </p>
                    </div>

                    {/* Right side: Image */}
                    <div className="FMS-image-container">
                        <img src={ACimage} alt="Air Conditioner Automation" className="FMS-image" />
                    </div>
                </div>

                {/* Centered Heading Between Images */}
                <div className="FMS-bottom-heading">
                    <h2 className="FMS-bottom-text">Key Features & Benefits</h2>
                </div>

                {/* Second Section: New Layout for Text and Image */}
                <div className="FMS-content-container">
                    {/* Left side: Text Content */}
                    <div className="FMS-text">
                        <p className="FMS-description">
                            <ul>
                                <li><strong>Real-Time Monitoring:</strong> Tracks temperature, energy usage, and system performance in real time.</li>
                                <li><strong>Smart Alerts:</strong> Sends instant notifications for system malfunctions, high energy consumption, or maintenance needs.</li>
                                <li><strong>Energy Optimization:</strong> Automatically adjusts settings to minimize energy waste while maintaining comfort.</li>
                                <li><strong>Usage Reports:</strong> Generates detailed reports on energy consumption and system efficiency for cost-saving decisions.</li>
                                <li><strong>Intuitive Dashboard:</strong> Provides a user-friendly interface for monitoring and controlling AC units.</li>
                            </ul>
                        </p>
                    </div>

                    {/* Right side: Image for Key Features */}
                    <div className="FMS-image-container">
                        <img src={ACimage2} alt="Key Features" className="FMS-image" />
                    </div>
                </div>

                {/* Centered Heading for How it Works */}
                <div className="FMS-bottom-heading">
                    <h2 className="FMS-bottom-text">How it Works</h2>
                </div>

                {/* Third Section: Layout for How it Works */}
                <div className="FMS-content-container">
                    {/* Left side: Image */}
                    <div className="FMS-image-container">
                        <img src={ACimage3} alt="How It Works" className="FMS-image" />
                    </div>

                    {/* Right side: Text Content */}
                    <div className="FMS-text">
                        <p className="FMS-description">
                            The Air Conditioner Automation system uses advanced sensors and IoT technology to monitor temperature, humidity, and energy consumption in real time. Data is transmitted to a centralized dashboard, allowing users to control AC units remotely and optimize settings for efficiency. Smart alerts notify users of system issues or maintenance needs, while detailed reports provide insights for better energy management.
                        </p>
                    </div>
                </div>

                {/* New Section: Why Choose Us */}
                <div className="FMS-bottom-heading">
                    <h2 className="FMS-bottom-text">Why Choose Our Air Conditioner Automation</h2>
                </div>

                <div className="FMS-content-container">
                    {/* Left side: Text Content */}
                    <div className="FMS-text">
                        <p className="FMS-description">
                            Our Air Conditioner Automation system offers unmatched efficiency and convenience, helping businesses and households reduce energy costs and enhance comfort. Key benefits include:
                            <ul>
                                <li>Real-time monitoring of temperature and energy usage</li>
                                <li>Smart alerts for proactive maintenance and issue resolution</li>
                                <li>Comprehensive dashboards for system control and analytics</li>
                                <li>Energy-efficient settings to reduce operational costs</li>
                                <li>Seamless integration with existing AC systems</li>
                            </ul>
                        </p>
                    </div>

                    {/* Right side: Image */}
                    <div className="FMS-image-container">
                        <img src={ACimage4} alt="Why Choose Us" className="FMS-image" />
                    </div>
                </div>

                {/* New Section: Industries Using Our System */}
                <div className="FMS-bottom-heading">
                    <h2 className="FMS-bottom-text">Industries Using Our Air Conditioner Automation</h2>
                </div>

                <div className="FMS-content-container reverse-order-last">
                    {/* Left side: Image for Industries */}
                    <div className="FMS-image-container">
                        <img src={ACimage5} alt="Industries Using AC Automation" className="FMS-image" />
                    </div>

                    {/* Right side: Text Content */}
                    <div className="FMS-text">
                        <p className="FMS-description">
                            Our Air Conditioner Automation system is trusted by various industries to enhance cooling efficiency and reduce energy costs. These industries rely on our solution for its reliability, scalability, and cost-saving benefits:
                            <ul>
                                <li>Commercial Buildings</li>
                                <li>Hospitality</li>
                                <li>Healthcare</li>
                                <li>Retail</li>
                                <li>Education</li>
                                <li>Data Centers</li>
                            </ul>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Airconditioner;